import React from 'react'

import {Box} from '@mui/material'

import {useProductLine} from '@progyny/hooks/useProductLine'
import ConsultationRow from '@progyny/pages/Consultations/components/ConsultationRow'
import NoConsultationView from '@progyny/pages/Consultations/components/NoConsultationView'
import SingleSessionBooking, {
  SessionForBooking,
} from '@progyny/pages/Consultations/components/SingleSession/SingleSessionBooking'

export interface SessionItem {
  sessionIndex: string
  title: string
  subtitle: string
  description: string
  language?: string
  status: string
  appointment: any
  required: boolean
}

export interface UpcomingSessionsProps {
  sessions: SessionItem[]
  colors?: any
  programSlug?: string
  t: (key: string) => string
  hasPast?: boolean
  onCancelRequested?: (cancelUrl: string) => void
  session?: SessionForBooking | null
  onCalendarVisibilityChange?: (visible: boolean) => void
  onBookingBack?: () => void
}

const UpcomingSessions: React.FC<UpcomingSessionsProps> = ({
  sessions,
  colors,
  programSlug,
  t,
  hasPast,
  onCancelRequested,
  session,
  onCalendarVisibilityChange,
  onBookingBack,
}) => {
  const {isFertility} = useProductLine()
  const [showBookingCalendar, setShowBookingCalendar] = React.useState(false)

  if (sessions.length === 0) {
    const bookableSession = isFertility ? session : undefined

    if (bookableSession && showBookingCalendar) {
      return (
        <SingleSessionBooking
          session={bookableSession}
          programSlug={programSlug ?? ''}
          onCalendarVisibilityChange={onCalendarVisibilityChange}
          onBackClick={() => {
            setShowBookingCalendar(false)
            onBookingBack?.()
          }}
        />
      )
    }

    return (
      <NoConsultationView
        isOnboarding={!hasPast}
        onBookClick={() => setShowBookingCalendar(true)}
      />
    )
  }

  return (
    <Box>
      {sessions.map((session, index) => (
        <ConsultationRow
          key={index}
          status='upcoming'
          sessionLabel={`${t('common_session')} ${session.sessionIndex}`}
          title={session.title}
          colors={colors}
          scheduledTime={session.appointment?.scheduledTime}
          language={session.appointment?.bookingLanguage}
          programSlug={programSlug}
          sessionNumber={Number(session.sessionIndex)}
          appointment={session.appointment}
          canJoin={session?.appointment?.canJoin}
          meetingLink={session?.appointment?.meetingLink}
          onCancelRequested={onCancelRequested}
        />
      ))}
    </Box>
  )
}

export default UpcomingSessions
